"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountFeature = void 0;
/**
 * If the contingency is active, these account features are unavailable
 * @TranslateToPython @TranslateToEnum
 */
var AccountFeature;
(function (AccountFeature) {
    // CoreCard ManualAccountStatus related contingencies
    AccountFeature["accountBlockedWhileContingencyActive"] = "accountBlockedWhileContingencyActive";
    AccountFeature["accountBankruptcyWhileContingencyActive"] = "accountBankruptcyWhileContingencyActive";
    AccountFeature["accountStatusClosedWhileContingencyActive"] = "accountStatusClosedWhileContingencyActive";
    AccountFeature["cashoutAndBalanceTransferUnavailableWhileContingencyActive"] = "cashoutAndBalanceTransferUnavailableWhileContingencyActive";
    AccountFeature["allCardsFrozenWhileContingencyActive"] = "allCardsFrozenWhileContingencyActive";
    AccountFeature["noInAppPaymentsOverRemainingDueWhileContingencyActive"] = "noInAppPaymentsOverRemainingDueWhileContingencyActive";
    /**
     * Cerberus blocks all purchase authorizations for this account.
     * This is set via Redis flag that the AccountBlockGatekeeper checks.
     * Used for high-risk new cardholder fraud prevention.
     */
    AccountFeature["cerberusBlocksAllPurchasesWhileContingencyActive"] = "cerberusBlocksAllPurchasesWhileContingencyActive";
    /**
     * Card activation is blocked while this contingency is active.
     * First use case: crypto BTC deposit gate. Extends AFC to pre-activation gating.
     */
    AccountFeature["cardActivationBlockedWhileContingencyActive"] = "cardActivationBlockedWhileContingencyActive";
    /**
     * Stops card activation and transactions while the contingency is active
     * Currently used for origination contingencies
     * In migration, currently does not block anything
     */
    AccountFeature["cardActivationAndTransactionsBlockedWhileContingencyActive"] = "cardActivationAndTransactionsBlockedWhileContingencyActive";
    /** Blocks upfront cash out draw while the fixed term debt swap activation AFC is active */
    AccountFeature["upfrontCashOutBlockedWhileContingencyActive"] = "upfrontCashOutBlockedWhileContingencyActive";
    /**
     * Allows only the upfront (debt swap) balance transfer while active; every other outbound transaction is blocked
     * and card activation is blocked until the contingency clears. In-app payments over remaining due are not blocked.
     */
    AccountFeature["onlyUpfrontBalanceTransferAllowedWhileContingencyActive"] = "onlyUpfrontBalanceTransferAllowedWhileContingencyActive";
    /** Non-blocking: gates only the application of a pending LA's terms (e.g. a post-activation increase awaiting its deposit), never card usage. Must stay out of MANUAL_STATUS_ACCOUNT_FEATURES. */
    AccountFeature["gatesPendingLoanApplicationTermsWhileContingencyActive"] = "gatesPendingLoanApplicationTermsWhileContingencyActive";
})(AccountFeature || (exports.AccountFeature = AccountFeature = {}));
